<section id="ChooseYourLegacySection" class="legacy-section position-relative overflow-hidden py-5">
    <div class="container py-5">

      <!-- Kicker -->
      <div class="d-flex justify-content-center align-items-center gap-3 text-uppercase text-xs fw-semibold legacy-kicker mb-2">
        <span class="legacy-kicker-line"></span>
        <span>{{ legacy_data.kicker }}</span>
        <span class="legacy-kicker-line"></span>
      </div>

      <!-- Title -->
      <h2 class="legacy-title text-center mb-2">
        {{ legacy_data.title }}
      </h2>

      <!-- Subtitle -->
      <div class="legacy-subtitle text-center mb-3">
        {{ legacy_data.subtitle }}
      </div>

      <!-- Lead -->
      <p class="legacy-lead text-center mx-auto mb-5">
        {{ legacy_data.description }}
      </p>

      <!-- Cards -->
      <div class="row g-4 justify-content-center">
        <div
          v-for="card in legacy_cards"
          :key="card.key"
          class="col-12 col-md-6 col-lg-3"
        >
          <div class="legacy-card h-100 rounded-4 p-4 d-flex flex-column">
            <!-- Icon box -->
            <div class="d-flex justify-content-center mb-3">
              <div class="legacy-icon-box d-flex align-items-center justify-content-center">
                <span class="legacy-icon">{{ card.icon }}</span>
              </div>
            </div>

            <!-- Category -->
            <div class="legacy-category text-uppercase text-xs fw-semibold text-center mb-2">
              {{ card.category }}
            </div>

            <!-- Name -->
            <div class="legacy-name text-center mb-2">
              {{ card.name }}
            </div>

            <!-- Price line -->
            <div class="legacy-price text-center mb-3">
              {{ card.price_line }}
            </div>

            <!-- Description -->
            <div class="legacy-card-desc text-center mb-4">
              {{ card.description }}
            </div>

            <div class="legacy-divider my-3"></div>

            <!-- Bullets -->
            <ul class="legacy-list text-xs mb-0">
              <li v-for="(b, i) in card.bullets" :key="i" class="d-flex align-items-start gap-2">
                <span class="legacy-dot mt-1"></span>
                <span>{{ b }}</span>
              </li>
            </ul>

            <div class="mt-auto"></div>
          </div>
        </div>
      </div>

    </div>
</section>
